module.exports = __webpack_public_path__ + "img/Kitchen.9e5b4960.jpg";